import React, { useState, useEffect, useCallback } from 'react';
import { Tabs, Tab, Box, Alert } from '@mui/material';
import BasicDets from './BasicDets/BasicDets';
import DateLocation from './Date&Loc/DateLocation';
import FinalDets from './FinalDets/FinalDets';
import MsgModalBox from '../../../container/MessageModalBox/MsgModalBox';
import axios from 'axios';
import moment from 'moment';
import {APIURL} from '../../../config'
import { Redirect } from 'react-router-dom';
import CircleIcon from '@mui/icons-material/Circle';
import Tooltip from '@mui/material/Tooltip';
import { convertTime } from 'src/utils/time';

const TabPanel = ({ children, value, tab }) => {
    return value === tab ? <Box sx={{ mt: 1 }}>{children}</Box> : null;
};

const TaskForm = (props) => {
    /* Props:
     * - locList: Array of location objects
     * - edit: Boolean indicating edit mode
     * - formVals: Form values object
     * - task_location: Task location data
     * - task_emp: Task employee assignments
     * - taskPriority: Task priority value
     * - taskIsBillable: Boolean for billable status
     * - tSigReq: Signature requirement flag
     * - taskComment: Task comments
     * - taskContacts: Array of task contacts
     * - user: Current user object
     * - comp_id: Company ID
     * - taskId: Task ID
     * - goHome: Callback function for navigation
     * - token: Authentication token
     * - mapRender: Map render state
     * - updateMapRender: Function to update map render
     * - customerPage: Boolean for customer page context
     * - cus_id: Customer ID
     * - empList: Array of employees
     * - isFormValidated: Boolean for form validation state
     */

    const companyAddress = (props.locList || []).filter((loc) => loc && loc.location_type === "Company")
    const com_lat = companyAddress.length === 0 ? 40.730610 : Number(companyAddress[0].location_lat)
    const com_lon = companyAddress.length === 0 ? -73.935242 : Number(companyAddress[0].location_lon)

    // Convert minutes to HH:MM format for display
    const convertMinutesToTimeString = (minutes) => {
        if (!minutes || minutes === 0) return "";
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
    };

    const [goHome, setGoHome] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [basicDetails, setBasicDetails] = useState({
        tTitle: props.edit ? props.formVals.tas_title : "",
        tDesc: props.edit ? props.formVals.tas_description : "",
        tProject: props.defaultProjectId ? props.defaultProjectId : "",
        tPreReq: props.edit ? (!!props.formVals.tas_prequisites_task ? props.formVals.tas_prequisites_task : "No Pre Req") : "No Pre Req",
        tType: props.edit ? props.formVals.tas_type : "",
    });
    const [dateLocation, setDateLocation] = useState({
        tStrtDate: props.edit ? moment(props.formVals.tas_start_time).format('YYYY-MM-DDTHH:mm:ss') : moment().format('YYYY-MM-DDTHH:mm:ss'),
        tEndDate: props.edit ? moment(props.formVals.tas_end_time).format('YYYY-MM-DDTHH:mm:ss') : moment().add(1, 'm').format('YYYY-MM-DDTHH:mm:ss'),
        tStartTime: props.edit ? moment(props.formVals.tas_start_time).format('YYYY-MM-DDTHH:mm:ss') : moment().format('YYYY-MM-DDTHH:mm:ss'),
        tEndTime: props.edit ? moment(props.formVals.tas_end_time).format('YYYY-MM-DDTHH:mm:ss') : moment().add(1, 'm').format('YYYY-MM-DDTHH:mm:ss'),
        tLoc: props.edit ? props.task_location?.map((loc, indx) => {if (loc) {return {value:loc?.loc_id,title: loc?.loc_addr_line1 + " " + loc?.loc_addr_line2 + ", " + loc?.loc_city + ", " + loc?.loc_state + ", " + loc?.loc_zip}}}) : [],
    });
    const [recurrenceDetails, setRecurrenceDetails] = useState(null);
    const [finalDetails, setFinalDetails] = useState({
        tAssTo: props.edit ? props.task_emp : "",
        tPriority: props.edit ? props.taskPriority : "Med",
        tIsBillable: props.edit ? props.taskIsBillable : true,
        tSigReq: props.edit ? (props.tSigReq === undefined ? 0 : props.tSigReq) : 0,
        tComment: props.edit ? props.taskComment : "",
        tContacts: props.edit ? (props.taskContacts?.map((contact) => {return {id: contact.con_id, label: contact.con_first_name + " " + contact.con_last_name}})) : [],
        tTravelTime: "",
        tExpenses: "",
    });
    const [task_emp_timezone, setTask_emp_timezone] = useState('');
    const [officeLocList, setOfficeLocList] = useState([]);
    const [tOloc, setTOloc] = useState(props.edit ? (props.formVals.tas_oloc_id ?? null) : null);
    const [mapPushPins, setMapPushPins] = useState([]);
    const [taskDates, setTaskDates] = useState([]);
    const [key, setKey] = useState("basicDetails");
    const [showModal, setShowModal] = useState(false);
    const [addError, setAddError] = useState(false);
    const [basicDetails_val, setBasicDetails_val] = useState(false);
    const [dateLocation_val, setDateLocation_val] = useState(false);
    const [finalDetails_val, setFinalDetails_val] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [showNoEmployeeAlert, setShowNoEmployeeAlert] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [loc_comp_pos] = useState([com_lat, com_lon]);
    const [showSelectWorkerField, setShowSelectWorkerField] = useState(false);
    const [locList, setLocList] = useState([]);
    const [taskAuthorizationStatus, setTaskAuthorizationStatus] = useState(null);
    const [taskAuthorizationText, setTaskAuthorizationText] = useState('');
    const [isServiceProvider] = useState(Array.isArray(props.user?.comp_settings) && props.user.comp_settings.find(setting => setting.feature_id === 102 && setting.feature_value === 'primaryBusinessType') ? true : false);
    const [isSupport] = useState(Array.isArray(props.user?.comp_settings) && props.user.comp_settings.find(setting => setting.feature_id === 101 && setting.feature_value === 'primaryBusinessType') ? true : false);
    const [empTasksAvailable, setEmpTasksAvailable] = useState(false);
    const [typeList, setTypeList] = useState([]);
    const [cust_id, setCust_id] = useState(null);
    const [contactList, setContactList] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [isCreatingTask, setIsCreatingTask] = useState(false);
    const [customerPreferences, setCustomerPreferences] = useState([]);

    // Effect to fetch project list on component mount
    useEffect(() => {
        const fetchProjects = async () => {
            if (!props.edit) {
                const response = await axios.get(APIURL + "/project/associated", {
                    params: { company_id: props.comp_id, employee_id: props.user.emp_id },
                });
                console.log('Fetched Projects:', response.data);
                setProjectList(response.data);
            }
        };

        fetchProjects();
    }, [props.edit, props.comp_id]);

    // Effect to fetch company office locations for the optional Office Location dropdown
    useEffect(() => {
        const fetchOfficeLocations = async () => {
            if (!props.comp_id) return;
            try {
                const response = await axios.get(APIURL + "/company/officeLocation", {
                    params: { company_id: props.comp_id },
                });
                const options = (Array.isArray(response.data) ? response.data : []).map((r) => ({
                    value: r.oloc_id,
                    title: [r.oloc_addr_line1, r.oloc_addr_line2, r.oloc_city, r.oloc_state, r.oloc_zip].filter(Boolean).join(', '),
                }));
                setOfficeLocList(options);
            } catch (err) {
                console.log(err);
            }
        };
        fetchOfficeLocations();
    }, [props.comp_id]);

    // Effect for project change - fetch task list
    useEffect(() => {
        const fetchTaskList = async () => {
            const taskListResponse = await axios.get(APIURL + "/dropdowns/dropdownType/taskslist", {
                params: { comp_id: props.comp_id, projID: basicDetails.tProject },
            });
            setTaskList(taskListResponse.data);
        };

        if (basicDetails.tProject) {
            fetchTaskList();
        }
    }, [basicDetails.tProject, props.comp_id]);

    // Effect for task authorization status
    useEffect(() => {
        const updateTaskAuthStatus = async () => {
            if (isServiceProvider) {
                let remainingUnits = await setTaskAuthStatus();
                setTaskAuthorizationStatus(!!remainingUnits ? remainingUnits : null);
                setTaskAuthorizationText(!!remainingUnits
                    ? remainingUnits > 0 ? "Under prior authorization limit" : "Exceeds prior authorization limit"
                    : ""
                );
            }
        };

        updateTaskAuthStatus();
    }, [basicDetails.tProject, basicDetails.tType, dateLocation.tStartTime, dateLocation.tEndTime, isServiceProvider]);

    // Effect for customer change - fetch task types
    useEffect(() => {
        const fetchTaskTypes = async () => {
            if (!empTasksAvailable && cust_id) {
                let custTasks = await axios.get(APIURL + "/customers/CustomerTasks", { params: { comp_id: props.comp_id, customer_id: cust_id } });
                let cusTaskTypes = [];
                if (custTasks.data.length !== 0) {
                    custTasks.data.forEach((task) => {
                        cusTaskTypes.push(task.EntityValue);
                    });
                    setTypeList(cusTaskTypes);
                    setBasicDetails({...basicDetails, tType: null});
                } else {
                    let taskTypes = await axios.get(APIURL + '/dropdowns/dropdownType/taskType', { params: { comp_id: props.comp_id, employeeType: props.user.type } });
                    setTypeList(taskTypes.data);
                    setBasicDetails({...basicDetails, tType: null});
                }
            }
        };

        fetchTaskTypes();
    }, [cust_id, empTasksAvailable, props.comp_id, props.user.type]);

    // Component mount effect
    useEffect(() => {
        const initialize = async () => {
            axios.defaults.headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                "Access-Control-Allow-Headers": '*',
                "Access-Control-Allow-Methods" : "PUT, GET, POST, DELETE, OPTIONS",
                "ACCESS-CONTROL-ALLOW-CREDENTIAL": true,
                Authorization: 'Bearer ' + window.localStorage.getItem('Fw4_access_Token')
            };

            let empTasks = await axios.get(APIURL + "/employees/EmployeeTasks", { params: { comp_id: props.user.comp_id, employee_id: props.user.emp_id } });
            if (empTasks.data.length !== 0) {
                let empTaskTypes = [];
                empTasks.data.forEach((task) => {
                    empTaskTypes.push(task.EntityValue);
                });
                setEmpTasksAvailable(true);
                setTypeList(empTaskTypes);

                if (props.edit) {
                    setBasicDetails(prev => ({...prev, tType: props.formVals.tas_type}));
                }
            } else if (!props.edit) {
                let taskTypes = await axios.get(APIURL + '/dropdowns/dropdownType/taskType', { params: { comp_id: props.comp_id, employeeType: props.user.type } });
                setTypeList(taskTypes.data);
            }

            if (!props.edit && props.defaultProjectId) {
                handleProjLoc(props.defaultProjectId, 'tProject');
                handleProjChange(props.defaultCustomerId, props.defaultProjectId);
            }

            if(props.edit) {
                if (!empTasksAvailable) {
                    let custTasks = await axios.get(APIURL + "/customers/CustomerTasks", { params: { comp_id: props.comp_id, customer_id: props.projList[0]?.cus_id } });
                    let cusTaskTypes = [];
                    if (custTasks.data.length !== 0) {
                        custTasks.data.forEach((task) => {
                            cusTaskTypes.push(task.EntityValue);
                        });
                        setTypeList(cusTaskTypes);
                        setBasicDetails(prev => ({...prev, tType: props.formVals.tas_type}));
                    } else {
                        let taskTypes = await axios.get(APIURL + '/dropdowns/dropdownType/taskType', { params: { comp_id: props.comp_id, employeeType: props.user.type } });
                        setTypeList(taskTypes.data);
                        setBasicDetails(prev => ({...prev, tType: props.formVals.tas_type}));
                    }
                }
                handleMapsPin({id: 'tLoc', value: dateLocation.tLoc});
                handleProjLoc(basicDetails.tProject, 'tProject');
                handleProjChange(props.projList[0]?.cus_id, basicDetails.tProject);
                
                // Fetch customer preferences for edit mode
                try {
                    const preferencesResponse = await axios.get(APIURL + "/customers/employeePreference", { 
                        params: { customer_id: props.projList[0]?.cus_id } 
                    });
                    setCustomerPreferences(preferencesResponse.data.preferences || []);
                } catch (err) {
                    console.error('Error fetching customer preferences in edit mode:', err);
                }
            }
        };

        initialize();
    }, []);

    const addTaskToDB = async (e) => {
        e.preventDefault();
        setIsCreatingTask(true);
        
        const newState = {
            basicDetails: {
                tTitle: "",
                tDesc: "",
                tProject: "",
                tPreReq: "",
                tType: "",
            },
            dateLocation: {
                tStrtDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
                tEndDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
                tLoc: [],
            },
            recurrenceDetails: null,
            contactList: [],
            finalDetails: {
                tAssTo: "",
                tPriority: "",
                tIsBillable: true,
                tSigReq: 0,
                tComment: "",
                tContacts: [],
                tTravelTime: "",
                tExpenses: "",
            }
        }
        e.persist()
        const startTime = moment(dateLocation.tStrtDate).format('YYYY-MM-DD') + "T" + moment(dateLocation.tStartTime).format('HH:mm:ss')
        const endTime = moment(dateLocation.tEndDate).format('YYYY-MM-DD') + "T" + moment(dateLocation.tEndTime).format('HH:mm:ss')
        
        var data = {
            empId : props.user.emp_id,
            empName: props.user.emp_name,
            company_id: props.comp_id,
            tTitle: basicDetails.tTitle,
            tDesc: basicDetails.tDesc,
            tProject: parseInt(basicDetails.tProject),
            tPreReq: parseInt(basicDetails.tPreReq),
            tType: basicDetails.tType,
            tStrtDate: startTime,
            tEndDate:  endTime,
            tStartTime: convertTime(startTime, moment.tz.guess(), task_emp_timezone, 'YYYY-MM-DDTHH:mm:ss') ?? startTime,
            tEndTime: convertTime(endTime, moment.tz.guess(), task_emp_timezone, 'YYYY-MM-DDTHH:mm:ss') ?? endTime,
            tLoc: dateLocation.tLoc[0]?.value || null,
            tLoc1: dateLocation.tLoc[1]?.value || null,
            tLoc2: dateLocation.tLoc[2]?.value || null,
            tOloc: tOloc || null,
            tAssTo: parseInt(finalDetails.tAssTo),
            tPriority: finalDetails.tPriority,
            tIsBillable: finalDetails.tIsBillable,
            tas_required_sig: finalDetails.tSigReq,
            tNotes: finalDetails.tComment,
            tContacts: finalDetails.tContacts,
            tTravelTime: (() => {
                if (!finalDetails.tTravelTime) return null;
                const parts = finalDetails.tTravelTime.split(':');
                if (parts.length !== 2) return null;
                const hours = parseInt(parts[0], 10);
                const minutes = parseInt(parts[1], 10);
                return isNaN(hours) || isNaN(minutes) ? null : hours * 60 + minutes;
            })(),
            tExpenses: finalDetails.tExpenses ? parseFloat(finalDetails.tExpenses) : null,
            taskId: props.taskId,
            user_id: props.user.emp_id,
            task_emp_timezone: task_emp_timezone || ''
        };
        let msg = null;

        
        if(props.edit){
            msg = await axios.put(APIURL+"/task", data);
        }else{
            if(recurrenceDetails !== null) {
                msg = await axios.post(APIURL+"/task/recurringTask", {...data, ...recurrenceDetails});
            } else {
                msg = await axios.post(APIURL+"/task", data);
            }
        }
        if (msg.status === 200) {
            // Create Note For Task
            let project_customer_id = (await axios.get(APIURL + `/project?proj_id=${basicDetails.tProject}&comp_id=${props.comp_id}`)).data.pro_customer_id
            
            try{
                if(finalDetails.tComment) {
                    let noteResponse = await axios.post(APIURL + `/comments`, {
                        cus_id: project_customer_id,
                        pro_id: parseInt(basicDetails.tProject),
                        tas_id: msg.data.id,
                        emp_id: props.user.emp_id,
                        comment_text: finalDetails.tComment,
                    })
                }
            } catch (err) {
                console.log(err)
            }

            e.target.reset();
            setBasicDetails(newState.basicDetails);
            setDateLocation(newState.dateLocation);
            setFinalDetails(newState.finalDetails);
            setTOloc(null);
            setRecurrenceDetails(newState.recurrenceDetails);
            setShowModal(true);
            setAddError(false);
            setIsCreatingTask(false);
            if(msg.data.tasks)
                setTaskDates(msg.data.tasks);
        } else {
            setAddError(true);
            setShowModal(true);
            setTaskDates([]);
            setIsCreatingTask(false);
            console.log("Error");
        }
    }

    const handleGoHome = (e) => {
        setAddError(false);
        setShowModal(false);
        setShowAlert(false);
        setShowNoEmployeeAlert(false);
        setBasicDetails_val(false);
        setDateLocation_val(false);
        setFinalDetails_val(false);
        
        if(props.goHome !== undefined) {
            props.goHome()
        } else {
            setGoHome(true);
        }
    }

    const addNew = (e) => {
        const newState = {
            goHome: false,
            basicDetails: {
                tTitle: "",
                tDesc: "",
                tProject: "",
                tPreReq: "No Pre Req",
                tType: "",
            },
            dateLocation: {
                tStrtDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
                tEndDate: moment().add(1, 'm').format('YYYY-MM-DDTHH:mm:ss'),
                tStartTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
                tEndTime: moment().add(1, 'm').format('YYYY-MM-DDTHH:mm:ss'),
                tLoc: [],
            },
            recurrenceDetails: null,
            finalDetails: {
                tAssTo: "",
                tPriority: "Med",
                tIsBillable: true,
                tSigReq: 0,
                tComment: "",
                tContacts: [],
            },
            mapPushPins: [],
            taskDates: [],
            key: "basicDetails",
            showModal: false,
            addError: false,
            basicDetails_val: false,
            dateLocation_val: false,
            finalDetails_val: false,
            showAlert: false,
            showNoEmployeeAlert: false,
            errorMsg: '',
            loc_comp_pos: [40.730610, -73.935242],
            showSelectWorkerField: false,
            locList: [],
            taskAuthorizationStatus: null,
            taskAuthorizationText: '',
            isServiceProvider: Array.isArray(props.user?.comp_settings) && props.user.comp_settings.find(setting => setting.feature_id === 102 && setting.feature_value === 'primaryBusinessType') ? true : false,
            isSupport: Array.isArray(props.user?.comp_settings) && props.user.comp_settings.find(setting => setting.feature_id === 101 && setting.feature_value === 'primaryBusinessType') ? true : false,
            cust_id: null,
            contactList: [],
            taskList:[],
            isCreatingTask: false,
            customerPreferences: [],
        }

        setGoHome(newState.goHome);
        setBasicDetails(newState.basicDetails);
        setDateLocation(newState.dateLocation);
        setRecurrenceDetails(newState.recurrenceDetails);
        setFinalDetails(newState.finalDetails);
        setMapPushPins(newState.mapPushPins);
        setTaskDates(newState.taskDates);
        setKey(newState.key);
        setShowModal(newState.showModal);
        setAddError(newState.addError);
        setBasicDetails_val(newState.basicDetails_val);
        setDateLocation_val(newState.dateLocation_val);
        setFinalDetails_val(newState.finalDetails_val);
        setShowAlert(newState.showAlert);
        setShowNoEmployeeAlert(newState.showNoEmployeeAlert);
        setErrorMsg(newState.errorMsg);
        setShowSelectWorkerField(newState.showSelectWorkerField);
        setLocList(newState.locList);
        setTaskAuthorizationStatus(newState.taskAuthorizationStatus);
        setTaskAuthorizationText(newState.taskAuthorizationText);
        setCust_id(newState.cust_id);
        setContactList(newState.contactList);
        setTaskList(newState.taskList);
        setIsCreatingTask(newState.isCreatingTask);
        setCustomerPreferences(newState.customerPreferences);
    }

    const onChange = (newKey) => {
        const conversion = {
            tTitle: 'Task title',
            tDesc: 'Task Description',
            tProject: 'Project',
            tType: 'Task type',
            tLoc: 'Location',
            tAssTo: 'tAssTo',
            tStrtDate: 'Start date',
            tStartTime: 'Start time',
            tEndDate: 'End date',
            tEndTime: 'End time',
            tContacts: 'Contacts',
        }

        const currentState = key === "basicDetails" ? basicDetails : key === "dateLocation" ? dateLocation : finalDetails;
        var validation = props.isFormValidated(currentState);
   
        if (!(validation.isValidated)) {
            if (key === "basicDetails") {
                setBasicDetails_val(false);
                setErrorMsg("Please enter "+conversion[validation.missingKey]);
            } else if (key === "dateLocation") {
                setDateLocation_val(false);
                setErrorMsg("Please enter "+conversion[validation.missingKey]);
            } else if (key === "finalDetails") {
                setFinalDetails_val(false);
                setErrorMsg("Please enter "+conversion[validation.missingKey]);
            } else {
                setFinalDetails_val(false);
            }
            setShowAlert(true);
            return false;
        } else {
            if (key === "basicDetails") {
                setBasicDetails_val(true);
            } else if (key === "dateLocation") {
                if (moment(dateLocation.tEndDate).isAfter(dateLocation.tStrtDate) && moment(dateLocation.tEndTime).isAfter(dateLocation.tStartTime)) {
                    setDateLocation_val(true);
                } else {
                    setErrorMsg(`End Date/Time must be after Start Date/Time.`);
                    setShowAlert(true);
                    return;
                }
            } else {
                setFinalDetails_val(true);
            }
            setShowAlert(false);
            setShowNoEmployeeAlert(false);
            setKey(newKey);
            return true;
        }
    }

    const handleProjChange = async (customer_id, project_id) => {
        try {
            let contacts = await axios.get(APIURL + '/project/projCont', { params: { proj_id: project_id } })
            contacts = contacts.data.map((contact) => ({
                id: contact.con_id,
                label: contact.con_first_name + " " + contact.con_last_name
            }))
            
            // Fetch customer preferences
            let preferences = [];
            try {
                const preferencesResponse = await axios.get(APIURL + "/customers/employeePreference", { 
                    params: { customer_id: customer_id } 
                });
                preferences = preferencesResponse.data.preferences || [];
            } catch (err) {
                console.error('Error fetching customer preferences:', err);
            }

            // Check if the project has employees assigned via projectEmployeeAssignment
            if (!props.edit && project_id) {
                try {
                    const peaResponse = await axios.get(APIURL + '/projemployees', { params: { pro_id: project_id, comp_id: props.comp_id } });
                    if (!peaResponse.data || peaResponse.data.length === 0) {
                        setErrorMsg('No employees are assigned to the selected project/customer. Please assign employees to this project before creating a task.');
                        setShowNoEmployeeAlert(true);
                    } else {
                        setShowNoEmployeeAlert(false);
                        if (showAlert === false) setErrorMsg('');
                    }
                } catch (err) {
                    console.error('Error checking project employee assignments:', err);
                }
            }
            
            setCust_id(customer_id);
            setContactList(contacts);
            setCustomerPreferences(preferences);
        } catch (err) {
            console.log(err)
        }
    }

    const handleProjLoc = (id, field) => {
        if(field === 'tProject'){
            axios.get(APIURL+'/location/v2', { params: { company_id: props.comp_id, project_id: id } }).then((res) => {
                let locations = res.data.map((loc) => ({
                    id: loc.loc_id,
                    location_addr1: loc.loc_addr_line1,
                    location_addr2: loc.loc_addr_line2,
                    location_city: loc.loc_city,
                    location_state: loc.loc_state,
                    location_zip: loc.loc_zip,
                    location_lat: loc.loc_lat,
                    location_lon: loc.loc_lon,
                }))
                setBasicDetails({...basicDetails, [field]: id});
                setDateLocation({ ...dateLocation});
                setFinalDetails(!props.edit ? { ...finalDetails, tAssTo: '' } : { ...finalDetails });
                setMapPushPins([]);
                setLocList(locations||[]);
            }).catch((err) => {
                console.log(err)
            })
        }else if(field === 'tPreReq'){
            setBasicDetails({...basicDetails, [field]: id});
        }else if(field === 'taskStartTime' || field === 'taskEndTime' || field === 'tStrtDate' ||  field === 'tEndDate' || field === 'tStartTime' || field === 'tEndTime'){
            let selectedProj = (props.edit ? (props.projList || []) : projectList).find((proj) => (proj && proj.pid === +basicDetails.tProject))
            let newDateLocation = { ...dateLocation }
            if (field === 'tStrtDate') {
                newDateLocation.tStrtDate = moment(id).format('YYYY-MM-DDTHH:mm:ss')
                newDateLocation.tEndDate = moment(id).format('YYYY-MM-DDTHH:mm:ss')
                setDateLocation(newDateLocation);
                return
            } else if (field === 'tEndDate') {
                if (selectedProj && moment(id).isBetween(selectedProj.start_date, selectedProj.end_date) && !!newDateLocation.tStrtDate && moment(id).isSameOrAfter(moment(newDateLocation.tStrtDate))) {
                    newDateLocation.tEndDate = moment(id).format('YYYY-MM-DDTHH:mm:ss')
                } else {
                    newDateLocation.tEndDate = ''
                    setDateLocation(newDateLocation);
                    setErrorMsg(`End Date must be between range ${selectedProj ? moment(selectedProj.start_date).format('DD MMM YYYY') + ' - ' + moment(selectedProj.end_date).format('DD MMM YYYY') : 'project dates'} and be Same or After ${moment().format('DD MMM YYYY')}`);
                    setShowAlert(true);
                    return
                }
            }else if (field === 'tStartTime') {
                let newTime = moment(id).format('YYYY-MM-DDTHH:mm:ss')
                if(moment(newDateLocation.tStrtDate.substring(0,10) + 'T' + newTime.substring(11)).isBefore(newDateLocation.tEndDate.substring(0,10) + 'T' + newDateLocation.tEndTime.substring(11))){
                    newDateLocation.tStartTime = newTime;
                }else{
                    newDateLocation.tStartTime = ''
                    setErrorMsg(`Start Time must be before ${moment(newDateLocation.tEndTime).format('hh:mm')} `);
                    setShowAlert(true);
                    return;
                }
               
            }else if (field === 'tEndTime') {
                let newTime = moment(id).format('YYYY-MM-DDTHH:mm:ss');
                if((moment(newDateLocation.tStrtDate.substring(0,10) + 'T' + newDateLocation.tStartTime.substring(11)).isBefore(newDateLocation.tEndDate.substring(0,10) + 'T' + newTime.substring(11)))){
                    newDateLocation.tEndTime = newTime;
                }else{
                    setErrorMsg(`End Time must be after range ${moment(newDateLocation.tStartTime).format('HH:mm')} `);
                    setShowAlert(true);
                    return
                }
            }else if (field === 'taskStartTime') {
                newDateLocation.tStrtDate = moment(id).format('YYYY-MM-DDTHH:mm:ss')
                newDateLocation.tStartTime = moment(id).format('YYYY-MM-DDTHH:mm:ss')
            }else if (field === 'taskEndTime') {
                newDateLocation.tEndDate = moment(id).format('YYYY-MM-DDTHH:mm:ss')
                newDateLocation.tEndTime = moment(id).format('YYYY-MM-DDTHH:mm:ss')
            } else {
                newDateLocation = { ...dateLocation, [field]: moment(id).format('YYYY-MM-DDTHH:mm:ss') }
            }
            setErrorMsg('');
            setShowAlert(false);
            setShowNoEmployeeAlert(false);
            setDateLocation(newDateLocation);
        }else if(field === 'tAssTo'){
            setFinalDetails({...finalDetails, [field]: id});
        }else if(field === 'task_emp_timezone'){
            setTask_emp_timezone(id);
        }
        else{
            setDateLocation({ ...dateLocation, [field]: id });
            setMapPushPins([]);
        }
    }

    const handleBasicDetsChange = (e) => {
        let newState = { ...basicDetails, [e.target.id]: e.target.value }
        setBasicDetails(newState);
    }

    const handleDateLocDetsChange = (e) => {
        let selectedProj = (props.edit ? (props.projList || []) : projectList).find((proj) => (proj && proj.pid === +basicDetails.tProject))
        let newDateLocation = { ...dateLocation }
        if (e.target.id === 'tStrtDate') {
            if (selectedProj && moment(e.target.value).isBetween(selectedProj.start_date, selectedProj.end_date) && moment(e.target.value).isSameOrAfter(moment().subtract(1, 'd'))) {
                newDateLocation.tStrtDate = e.target.value
            } else {
                newDateLocation.tStrtDate = ''
                setDateLocation(newDateLocation);
                setErrorMsg(`Start Date must be between range ${selectedProj ? moment(selectedProj.start_date).format('DD MMM YYYY') + ' - ' + moment(selectedProj.end_date).format('DD MMM YYYY') : 'project dates'} and be same or after ${moment().format('DD MMM YYYY')}`);
                setShowAlert(true);
                return
            }
        } else if (e.target.id === 'tEndDate') {
            if (selectedProj && moment(e.target.value).isBetween(selectedProj.start_date, selectedProj.end_date) && !!newDateLocation.tStrtDate && moment(e.target.value).isSameOrAfter(moment(newDateLocation.tStrtDate))) {
                newDateLocation.tEndDate = e.target.value
            } else {
                newDateLocation.tEndDate = ''
                setDateLocation(newDateLocation);
                setErrorMsg(`End Date must be between range ${selectedProj ? moment(selectedProj.start_date).format('DD MMM YYYY') + ' - ' + moment(selectedProj.end_date).format('DD MMM YYYY') : 'project dates'} and be Same or After ${moment().format('DD MMM YYYY')}`);
                setShowAlert(true);
                return
            }
        } else {
            newDateLocation = { ...dateLocation, [e.target.id]: e.target.value }
        }
        setErrorMsg('');
        setShowAlert(false);
        setShowNoEmployeeAlert(false);
        setDateLocation(newDateLocation);
    }

    const handleMapsPin = (e) => {
        let newState = { ...dateLocation, [e.id]: e.value }
        let chosenLocIds = e.value;
        console.log(e.value)
        let chosenLocs = null
        if (!!props.edit) {
            console.log(props.locList)
            chosenLocs = locList.filter(({ id }) => chosenLocIds.map(e => e.value).includes(id))
        } else {
            console.log(props.locList)
            chosenLocs = locList.filter(({ id }) => chosenLocIds.map(e => e.value).includes(id))
        }
        console.log(chosenLocs)
        setDateLocation(newState);
        let newMapPin = [];
        if (e.value === "" || e.value.length === 0 || !chosenLocs) {
            newMapPin = []
        } else {
            if (props.edit) {
                newMapPin = chosenLocs.map((loc) => ({
                    "location": [+loc.loc_lat, +loc.loc_lon],
                    "infoboxOption": { title: loc.loc_city, visible: true, description: loc.loc_addr_line1 + ','  + loc.loc_addr_line2 },
                    "pushPinOption": { title: 'Task Location' }
                }))
            } else {
                newMapPin = chosenLocs.map((loc) => ({
                    "location": [+loc.location_lat, +loc.location_lon],
                    "infoboxOption": { title: loc.location_city, visible: true, description: loc.location_addr1 + ',' + loc.location_addr2 },
                    "pushPinOption": { title: 'Task Location' }
                }))
            }
        }
        console.log(newMapPin);
        setMapPushPins(newMapPin);
    }

    const handleFinalDetsChange = (e) => {
        let newFinalDetails = { ...finalDetails };
        if (e.target.id === "radioLow") {
            newFinalDetails.tPriority = "Low"
        } else if (e.target.id === "tNotes"){
            newFinalDetails.tComment = e.target.value
        } else if (e.target.id === "radioMed") {
            newFinalDetails.tPriority = "Med"
        } else if (e.target.id === "radioHigh") {
            newFinalDetails.tPriority = "High"
        } else if (e.target.id === "radioBillYes") {
            newFinalDetails.tIsBillable = true
        } else if (e.target.id === "radioBillNo") {
            newFinalDetails.tIsBillable = false
        } else if (e.target.id === "radioSigYes") {
            newFinalDetails.tSigReq = 1
        } else if (e.target.id === "radioSigNo") {
            newFinalDetails.tSigReq = 0
        } else {
            newFinalDetails = { ...finalDetails, [e.target.id]: e.target.value }
        }
        setFinalDetails(newFinalDetails);
    }

    const handleRadioButtonToggle = (e) => {
        const value = e.target.value
        if (value === 'select worker') {
            setShowSelectWorkerField(true);
        } else {
            setShowSelectWorkerField(false);
        }
    }

    const handleRecurrenceSubmit = (recDets) => {
        let selectedProj = (props.edit ? (props.projList || []) : projectList).find((proj) => (proj && proj.pid === +basicDetails.tProject));
        recDets.projectEndDate = selectedProj?.end_date;
        setRecurrenceDetails(recDets);
        console.log(recDets);
    }

    const handleRecurrenceCancel = () => {
        setRecurrenceDetails(null);
    }

    const getEmpList = () => {
        try{
            if (props.edit) {
                return props.empList;
            }
            if (!basicDetails.tProject) {
                return [];
            }
            const foundProject = projectList.find((proj) => proj && proj.pid === +basicDetails.tProject);
            const fromAssn = foundProject?.empAssn?.map((relEmp) => {
                const relEmpId = relEmp?.id ?? relEmp?.emp_id ?? relEmp?.employee_id;
                if ((props.empList || []).some((emp) => (emp?.id ?? emp?.emp_id) === relEmpId)) {
                    return (props.empList || []).find((rEmp) => rEmp && (rEmp.id ?? rEmp.emp_id) === relEmpId);
                }
                return null;
            }).filter(Boolean);
            // If projectList has loaded and found the project, use empAssn filtering;
            // otherwise fall back to the full props.empList (project employees passed in directly)
            let empList = (fromAssn && fromAssn.length > 0) ? fromAssn : (foundProject ? [] : (props.empList || []));
            empList = empList || [];
            
            // Sort by customer preference (descending, null/undefined treated as 0)
            if (customerPreferences && customerPreferences.length > 0 && empList && empList.length > 0) {
                empList = [...empList].sort((a, b) => {
                    const prefA = customerPreferences.find(p => p.employee_id === a?.id);
                    const prefB = customerPreferences.find(p => p.employee_id === b?.id);
                    
                    const levelA = prefA?.preference_level ?? 0;
                    const levelB = prefB?.preference_level ?? 0;
                    
                    return levelB - levelA;
                });
            }
            
            return empList;
        } catch(err){
            setErrorMsg('Please ensure that the project being selected has an employee assigned to it!');
            setShowNoEmployeeAlert(true);
            setBasicDetails({...basicDetails, tProject: ''});
            return []
        }
    }

    const calculateStatus = (tasks, preAuth) => {
        let allowedUnits = preAuth.authUnits;
        let completedUnits = 0, totalUnits = 0;
        let unit = preAuth.procUnitOfService;
        let duration = moment(dateLocation.tEndTime).isValid() && moment(dateLocation.tStartTime).isValid() ?
        moment.duration(moment(dateLocation.tEndTime).diff(moment(dateLocation.tStartTime))) : moment.duration(0)

        switch(unit) {
            case '15 Minutes':
                tasks.forEach((task) => {
                    let taskDuration = moment.duration(moment(task.checkoutEmpDate).diff(moment(task.empLocdate))).asMinutes();
                    let roundedUnits = taskDuration < 15 ? 1 : Math.round(taskDuration / 15);
                    if(moment(task.checkoutEmpDate).isBefore(moment()))
                        completedUnits += roundedUnits;
                    totalUnits += roundedUnits;
                })
                duration  = duration.asMinutes() < 0 ? 0 : duration.asMinutes();
                duration = duration < 15 ? 1 : Math.round(duration / 15);
                break;
            case '1 Hour':
                tasks.forEach((task) => {
                    let taskDuration = moment.duration(moment(task.checkoutEmpDate).diff(moment(task.empLocdate))).asHours();
                    let roundedUnits = taskDuration < 1 ? 1 : Math.round(taskDuration);
                    if(moment(task.checkoutEmpDate).isBefore(moment()))
                        completedUnits += roundedUnits;
                    totalUnits += roundedUnits;
                })
                duration = duration.asHours() < 0 ? 0 : duration.asHours();
                duration = duration < 1 ? 1 : Math.round(duration);
                break;
            case 'Per Diem':
                tasks.forEach((task) => {
                    if(moment(task.checkoutEmpDate).isBefore(moment()))
                        completedUnits += 1;
                    totalUnits += 1;
                })
                duration = 1;
                break;
            case 'Per Visit':
                tasks.forEach((task) => {
                    if(moment(task.checkoutEmpDate).isBefore(moment()))
                        completedUnits += 1;
                    totalUnits += 1;
                });
                duration = 1;
                break;
            default:
                break;
        }

        if(completedUnits > allowedUnits){
            return -1;
        } else if(totalUnits > allowedUnits){
            return 0;
        } else if (totalUnits + duration > allowedUnits){
            return 0;
        } else {
            return 1;
        }
    }

    const setTaskAuthStatus = async () => {
        if (!cust_id || !basicDetails.tType || basicDetails.tType === '') {
            return null;
        }
        
        const selectedDate = dateLocation.tStartTime;

        let preAuthList = await axios.get(APIURL + '/preAuth/taskType', { 
            params: { 
                companyID: props.comp_id, 
                taskType: basicDetails.tType,
                fromDate: moment(selectedDate).isValid() ? moment(selectedDate).subtract(2, 'months').format('MM/DD/YYYY') : null,
                toDate: moment(selectedDate).isValid() ? moment(selectedDate).endOf("day").format('MM/DD/YYYY') : null 
            } 
        });

        preAuthList = preAuthList.data.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

        const preAuth = preAuthList.find(item => item.cus_id === cust_id);
        const remainingUnits = preAuth ? Math.max(0, preAuth.remainingUnits) : null;

        return remainingUnits;
    }

    // MUI Tabs don't render Tab children; implement TabPanel for content rendering.

    const basicLabel = basicDetails_val ? (
        <div className="d-flex flex-column"><i style={{ fontSize: '0.7rem' }} className="fas fa-check text-center"></i><div style={{ margin: '-2px', fontSize: '0.9rem' }}>Basic Details</div></div>
    ) : (<div style={{ margin: '-1px' }}>Basic Details</div>);
    const dateLocLabel = dateLocation_val ? (
        <div className="d-flex flex-column"><i style={{ fontSize: '0.7rem' }} className="fas fa-check text-center"></i><div style={{ margin: '-2px', fontSize: '0.9rem' }}>Date & Location</div></div>
    ) : (<div style={{ margin: '-1px' }}>Date & Location</div>);
    const finalLabel = finalDetails_val ? (
        <div className="d-flex flex-column"><i style={{ fontSize: '0.7rem' }} className="fas fa-check text-center"></i><div style={{ margin: '-2px', fontSize: '0.9rem' }}>Final Details</div></div>
    ) : (<div style={{ margin: '-1px' }}>Final Details</div>);

    return (
        <div style={{ textAlign: 'left' }}>
            {showModal ? (
                <MsgModalBox edit={props.edit} taskDates={taskDates} addNew={addNew} goHome={handleGoHome} text="Task" showError={addError} style={{ position: 'absolute' }} />
            ) : (
                <Box component="form" onSubmit={(e) => { if (onChange('finalDetails')) { addTaskToDB(e); } else { e.preventDefault(); } }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h4 style={{ margin: '5px', marginBottom: '20px', width: '100%' }}>{props.edit ? '' : props.customerPage ? '' : 'New Task'} </h4>
                        {!!taskAuthorizationStatus && (
                            <Tooltip title={taskAuthorizationText} placement="right">
                                <CircleIcon sx={{ color: taskAuthorizationStatus > 0 ? 'green' : taskAuthorizationStatus < 0 ? 'red' : 'yellow', alignSelf: 'center', size: 'large' }} />
                            </Tooltip>
                        )}
                    </div>
                    {showAlert && (
                        <Alert severity="info">
                            {!errorMsg ? 'Please Fill out missing form fields' : errorMsg}
                        </Alert>
                    )}
                    {showNoEmployeeAlert && (
                        <Alert severity="info">
                            {!errorMsg ? 'Please ensure that the project being selected has an employee assigned to it!' : errorMsg}
                        </Alert>
                    )}
                    <Tabs value={key} onChange={(e, val) => onChange(val)}>
                        <Tab value="basicDetails" label={basicLabel} />
                        <Tab value="dateLocation" label={dateLocLabel} />
                        <Tab value="finalDetails" label={finalLabel} />
                    </Tabs>
                    <TabPanel value={key} tab="basicDetails">
                        <BasicDets
                            edit={props.edit}
                            taskList={taskList}
                            projList={props.edit ? (Array.isArray(props.projList) ? props.projList : []) : (Array.isArray(projectList) ? projectList : [])}
                            taskType={typeList}
                            empList={props.empList}
                            formVals={basicDetails}
                            project_name={props.edit ? (Array.isArray(props.projList) && props.projList[0]?.pname) : ''}
                            pre_task_name={props.edit ? (props.formVals.tas_prequisites_name ? props.formVals.tas_prequisites_name : 'NO TASK PREREQUISITE') : 'NO TASK PREREQUISITE'}
                            onContinue={onChange}
                            handleProjLoc={handleProjLoc}
                            handleProjChange={handleProjChange}
                            handleBasicDetsChange={handleBasicDetsChange}
                            handleRadioButtonToggle={handleRadioButtonToggle}
                            showSelectWorkerField={showSelectWorkerField}
                            isSupport={isSupport}
                            user={props.user}
                            customerPage={props.customerPage}
                            cus_id={props.cus_id}
                        />
                    </TabPanel>
                    <TabPanel value={key} tab="dateLocation">
                        <DateLocation
                            edit={props.edit}
                            token={props.token}
                            mapRender={props.mapRender}
                            locList={locList}
                            officeLocList={officeLocList}
                            tOloc={tOloc}
                            onOfficeLocChange={setTOloc}
                            currentPin={loc_comp_pos}
                            task_location={props.edit ? props.task_location[0] : ''}
                            timeAlloc={[dateLocation.tStartTime, dateLocation.tEndTime]}
                            timeIndicator={[dateLocation.timeStrtIndicator, dateLocation.timeEndIndicator]}
                            project={(props.edit ? (Array.isArray(props.projList) ? props.projList : []) : (Array.isArray(projectList) ? projectList : [])).find((proj) => proj && proj.pid === +basicDetails.tProject)}
                            handleDateLocDetsChange={handleDateLocDetsChange}
                            formVals={dateLocation}
                            handleMapsPin={handleMapsPin}
                            handleTimer={undefined}
                            mapsPushPin={mapPushPins}
                            onContinue={onChange}
                            error={errorMsg}
                            handleProjLoc={handleProjLoc}
                            handleTimerIdicator={undefined}
                            updateMapRender={props.updateMapRender}
                            handleRecurrenceSubmit={handleRecurrenceSubmit}
                            handleRecurrenceCancel={handleRecurrenceCancel}
                        />
                    </TabPanel>
                    <TabPanel value={key} tab="finalDetails">
                        <FinalDets
                            edit={props.edit}
                            handleProjLoc={handleProjLoc}
                            handleFinalDetsChange={handleFinalDetsChange}
                            formVals={finalDetails}
                            empList={getEmpList()}
                            contactList={contactList}
                            user={props.user}
                            isCreatingTask={isCreatingTask}
                        />
                    </TabPanel>
                </Box>
            )}
            {goHome && <Redirect to="/" />}
        </div>
    );
};

export default TaskForm;